import React from "react";
import { useState } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input } from "reactstrap";
import API from "../../../api/API";
import {
  CHANGE_LANGUAGE,
  CREATE_PROFILE,
  UPDATE_PROFILE,
} from "../../../api/user";
import { EMPTY_VALIDATION, USER_DEFAULT_LANGUAGE } from "../../../constants";
import {
  changeLanguage,
  showToast,
  t,
  validarCampos,
} from "../../../utils/utils";
import T from "../../atoms/translate";

const UpdateProfile = ({ client, profile, profileExists }) => {
  const [data, setData] = useState({
    id: profile.id,
    email: profile.email,
    firstName: profile.firstName,
    lastName: profile.lastName,
    address: profile.address,
    language: profile.language,
    birthDate: "",
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const labels = {
    email: "",
    firstName: "",
    lastName: "",
    address: "",
    language: "",
  };
  const validations = {
    firstName: [EMPTY_VALIDATION],
    lastName: [],
    address: [],
  };

  const onChange = async (evt) => {
    const target = evt.target;
    let newData = { ...data };
    newData[target.name] = target.value;
    setData(newData);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const newErrors = {
      ...validarCampos(data, validations, errors, labels, ["firstName"]),
    };

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      showToast(t("corrijaLosErrores"), "error");
      setSaving(false);
      return;
    }

    //mutacion perfil
    try {
      const params = {
        name: data.firstName,
        last_name: data.lastName,
        address: data.address,
        birth_date: new Date(),
      };
      if (profileExists) {
        params.id = data.id;
      }
      const res = await API.mutation(
        client,
        profileExists ? UPDATE_PROFILE : CREATE_PROFILE,
        params
      );
      await API.mutation(client, CHANGE_LANGUAGE, {
        locale: data.language,
      });
      changeLanguage(data.language);
      localStorage.setItem(USER_DEFAULT_LANGUAGE, data.language);
      if (
        res &&
        res.data &&
        (res.data.createProfile || res.data.updateProfile)
      ) {
        showToast(t("perfilActualizadoExitosamente"));
      } else {
        showToast(t("errorAlActualizarPerfil"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorAlActualizarPerfil"), "error");
      } else {
        showToast(t("errorAlActualizarPerfil"), "error");
      }
    }
    setSaving(false);
  };

  return (
    <Form onSubmit={onSubmit}>
      <Row form>
        <Col md={4}>
          <FormGroup>
            <Label for="email">
              <T i18nKey={"email"} />
            </Label>
            <Input
              type="email"
              name="email"
              id="email"
              defaultValue={data.email}
              readOnly
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="firstName">
              <T i18nKey={"nombre"} />
            </Label>
            <Input
              type="text"
              name="firstName"
              id="firstName"
              autoComplete="off"
              defaultValue={data.firstName}
              placeholder={t("ingresaTuNombre")}
              onBlur={onChange}
              className={`${errors.firstName ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.firstName}</div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="lastName">
              <T i18nKey={"apellido"} />
            </Label>
            <Input
              type="text"
              name="lastName"
              id="lastName"
              defaultValue={data.lastName}
              placeholder={t("ingresaTuApellido")}
              onBlur={onChange}
              className={`${errors.lastName ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.lastName}</div>
          </FormGroup>
        </Col>
      </Row>
      <Row form>
        <Col md={4}>
          <FormGroup>
            <Label for="language">
              <T i18nKey={"idiomaEditor"} />
            </Label>
            <Input
              type="select"
              name="language"
              id="language"
              value={data.language}
              onChange={onChange}
            >
              <option value="en">{t("ingles")}</option>
              <option value="es">{t("espanol")}</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={8}>
          <FormGroup>
            <Label for="address">
              <T i18nKey={"direccion"} />
            </Label>
            <Input
              type="text"
              name="address"
              id="address"
              defaultValue={data.address}
              placeholder={t("ingresaTuDireccion")}
              onBlur={onChange}
              className={`${errors.address ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.address}</div>
          </FormGroup>
        </Col>
      </Row>

      <Row form>
        <Col xs="12" md="5" className="mx-auto mt-3">
          <Button color="primary" block type="submit" disabled={saving}>
            {saving ? t("espere...") : t("guardar")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default UpdateProfile;
